import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

function useIndicators() {
  return useQuery({
    queryKey: ['indicators'],
    queryFn: async () => {
      const { data } = await axios.get('/api/indicators');
      return data;
    },
  });
}

function useParameters() {
  return useQuery({
    queryKey: ['parameters'],
    queryFn: async () => {
      const { data } = await axios.get('/api/parameters');
      return data;
    },
  });
}

function useMeasurementStations() {
  return useQuery({
    queryKey: ['measurement-stations'],
    queryFn: async () => {
      const { data } = await axios.get('/api/measurement-stations/2');
      return data;
    },
  });
}

function useContaminants() {
  return useQuery({
    queryKey: ['contaminants'],
    queryFn: async () => {
      const { data } = await axios.get('/api/beaches/greece/contaminants');
      return data;
    },
  });
}

function useObservations() {
  return useQuery({
    queryKey: ['observations'],
    queryFn: async () => {
      const { data } = await axios.get('/api/beaches/barcelona/observations');
      return data;
    },
  });
}

function useLandUse() {
  return useQuery({
    queryKey: ['land-use'],
    queryFn: async () => {
      const { data } = await axios.get('/api/scenarios/land-use');
      return data;
    },
  });
}

function useCommunities() {
  return useQuery({
    queryKey: ['communities'],
    queryFn: async () => {
      const { data } = await axios.get('/api/scenarios/communities');
      return data;
    },
  });
}

function useDataLayerResources() {
  return useQuery({
    queryKey: ['data-layer-resources'],
    queryFn: async () => {
      const { data } = await axios.get('/api/data-layers/resources');
      return data;
    },
  });
}

export {
  useIndicators,
  useParameters,
  useMeasurementStations,
  useContaminants,
  useObservations,
  useLandUse,
  useCommunities,
  useDataLayerResources,
};
